import { Grid } from '@mui/material';
import {
  DateRangePicker,
  FiltersButtons,
  FiltersLayout,
  SearchField
} from '../../../../components';
import { FC, useState } from 'react';
import { IDateRange } from '../../../../models';

interface IPendingContractsFiltersProps {
  applyFilters: (data: { startSentAt?: string; endSentAt?: string; search?: string }) => void;
}

export const PendingContractsFilters: FC<IPendingContractsFiltersProps> = ({ applyFilters }) => {
  const [selectedDateRange, setSelectedDateRange] = useState<IDateRange>({
    startDate: null,
    endDate: null,
    key: 'selection',
    inputValue: ''
  });
  const [searchValue, setSearchValue] = useState<string>('');
  const [hasAppliedFilters, setHasAppliedFilters] = useState<boolean>(false);
  return (
    <FiltersLayout hasMarginBottom={false}>
      <Grid item xs={12} sm={6} md={3}>
        <SearchField
          isDisabled={false}
          placeholder="Search by vendor name or contract name"
          handleSearch={() => {
            setHasAppliedFilters(true);
            applyFilters({
              search: searchValue.trim() || undefined,
              startSentAt: selectedDateRange?.startDate
                ? selectedDateRange?.startDate?.toISOString()
                : undefined,
              endSentAt: selectedDateRange?.endDate
                ? selectedDateRange?.endDate?.toISOString()
                : undefined
            });
          }}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <DateRangePicker
          id="pending-contracts-date-range"
          label="Contract Sent"
          value={selectedDateRange}
          onChange={value => {
            if (value) {
              setSelectedDateRange(value);
            }
          }}
          fullWidth
          inputSize="small"
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            applyFilters({
              startSentAt: selectedDateRange?.startDate
                ? selectedDateRange?.startDate?.toISOString()
                : undefined,
              endSentAt: selectedDateRange?.endDate
                ? selectedDateRange?.endDate?.toISOString()
                : undefined,
              search: searchValue
            });
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSelectedDateRange(undefined);
            setSearchValue('');
            applyFilters({
              startSentAt: undefined,
              endSentAt: undefined,
              search: ''
            });
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};
